import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ROLE_HOME = {
  cliente: "/cliente",
  admin: "/admin",
  conductor: "/conductor",
};

/**
 * Protege una rama de rutas por sesión y, opcionalmente, por rol.
 * - Sin usuario autenticado -> redirige a /login.
 * - Usuario autenticado pero con rol no permitido -> redirige a SU panel
 *   (no a /login, para no hacerlo parecer un fallo de sesión).
 */
export const ProtectedRoute = ({ allowedRoles, children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0D0E10] flex items-center justify-center text-[#A0A0A5] text-sm font-body">
        Cargando…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={ROLE_HOME[user.role] || "/"} replace />;
  }

  return children;
};

export default ProtectedRoute;
